<template>
    <div class="page-content">
        <div class="page-body">
            <div class="body-item">
                <div class="f-16 mb-10 fw-b">确认订单信息</div>
                <el-form label-width="100px" label-position="right">
                    <el-form-item style="margin: 0;" label="服务类型：">{{form.type<=1?'接机':'送机'}}</el-form-item>
                    <el-form-item style="margin: 0;" label="目的地：">{{form.site}}</el-form-item>
                    <el-form-item style="margin: 0;" :label="`${form.type<=1?'接机':'送机'}时间：`">{{form.time}}</el-form-item>
                    <el-row :gutter="20">
                        <el-col :span="7">
                            <el-form-item style="margin: 0;" label="人数：" required>
                                <el-select v-model="form.people" placeholder="请选择人数" filterable style="width: 160px">
                                    <el-option v-for="(item,index) in numAry"
                                               :key="index"
                                               :label="`${item}人`"
                                               :value="item"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                            <el-form-item style="margin: 0;" label="行李：" required>
                                <el-select v-model="form.luggage" placeholder="请选择人数" filterable style="width: 160px">
                                    <el-option label="无" :value="0"></el-option>
                                    <el-option v-for="(item,index) in numAry"
                                               :key="index"
                                               :label="`${item}件`"
                                               :value="item"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="body-item">
                <div class="f-16 mb-10 fw-b">确认订单信息</div>
                <el-form label-width="100px" label-position="right">
                    <el-form-item label="联系人：" required>
                        <el-input placeholder="请输入联系人" v-model="contact" style="width: 220px;"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号：" required>
                        <el-input placeholder="请输入手机号" v-model="telphone" style="width: 220px;"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="body-item">
                <div class="f-16 mb-10 fw-b">其他信息</div>
                <el-form label-width="100px" label-position="right">
                    <el-form-item label="协办登机：" required>
                        <el-switch
                                v-model="help"
                                :active-value="1"
                                :inactive-value="0"
                                active-text="是"
                                inactive-text="否">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="备注信息：" required>
                        <el-input v-model="remark" placeholder="可选填留言备注信息，如：是否需要儿童座椅，对车辆清洁要求等" type="textarea"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div class="body-item">
                <div class="f-16 mb-20 fw-b">订单规则</div>
                <div class="f-14 mb-10 ml-30" v-for="(item,index) in driverRules" :key="index">{{item.title}}</div>
            </div>
            <el-button type="primary" :loading="loading" class="mt-30 mb-20" style="margin-right: auto" @click="handlerIssue">确认发布</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "shuttleReservation",
        data() {
            return {
                loading: false,
                numAry: Array.from({length: 15}, (item, index) => index + 1),
                form: {
                    type: 1,
                    flight: '',
                    site: '',
                    time: '',
                    people: 1,
                    luggage: 0,
                    airport: '',
                    area: '',
                },
                contact: '',
                telphone: '',
                remark: '',
                help: 1,
                driverRules: []
            }
        },
        created() {
            this.form = JSON.parse(decodeURIComponent(this.$route.query.params));
            this.getDriverRules();
        },
        methods: {
            async getDriverRules() {
                let [e, data] = await this.$api.getDriverRulesApi();
                this.driverRules = data.result;
            },
            async handlerIssue(){
                let params = {
                    airport_id: this.form.airport,
                    area_id: this.form.area,
                    address: this.form.site,
                    flight: this.form.flight,
                    time: this.form.time,
                    people: this.form.people,
                    bags: this.form.luggage,
                    type: this.form.type,
                    contact: this.contact,//联系人
                    telphone: this.telphone,
                    remark: this.remark,
                    help: this.help
                }
                let [e, data] = await this.$api.driverCarPlaneAddApi(params);
                console.log(data);
                if(data.code === 200){
                    this.$message.success('发布成功！');
                    this.$router.back();
                }else {
                    this.$message.warning(data.error)
                }
            }
        },
    }
</script>

<style scoped lang="less">
    .page-content{
        padding: 20px;
        box-sizing: border-box;
    }
    .page-body{
        width: 900px;
        margin-left: auto;
        margin-right: auto;
        background-color: #ffffff;
        box-shadow: 3px 3px 6px #A6A6A6;
        .body-item{
            padding: 20px;
            box-sizing: border-box;
            border-bottom: 1px solid #e2e2e2;
            text-align: left;
            &:last-child{
                border-bottom: none;
            }
        }
    }

    .page-title{

    }
</style>
